import React, { Fragment } from "react";
import { makeStyles } from "tss-react/mui";

// @mui/icons-material

// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import JobsSidebar from "../JobsSidebar";

import { SanitizeHTML } from "../../util/string";
import {getHostname, updateQueryString} from "../../util/url";

import { secondaryColor } from "../../styles/jss/nextjs-material-kit";
import styles from "../../styles/jss/nextjs-material-kit/pages/landingPageSections/TheDetailsStyle.js";
import overviewStyles from "../../styles/jss/nextjs-material-kit/pages/componentsSections/jobOverviewStyle.js";
import Grid from "@mui/material/Grid";
import {
  useFavouritesAddRequest,
  useStudentFavouritesListRequest,
} from "../../request/api";
import { useAuthContext } from "../../contexts/auth";
import { ROLE_SCHOOL_USER_ID } from "../../util/roles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import {useRouter} from "next/router";

const useStyles = makeStyles()(styles);
const useOverviewStyles = makeStyles()(overviewStyles);

export default function CareerZoneDetails({ careerZone }) {
  const { classes, cx } = useStyles();
  const { classes: overviewClasses } = useOverviewStyles();
  const {
    isMutating: isUpdatingFavourites,
    trigger: addToFavourites,
    error: favouritesError,
  } = useFavouritesAddRequest(
    { type: "careerzones", entityId: careerZone?.id },
    undefined,
    { withCredentials: true }
  );
  const { auth } = useAuthContext();
  const router = useRouter();

  const {
    data: favouritesData,
    error: favouritesErrors,
    isLoading: isLoadingFavourites,
    mutate: updateFavourites,
  } = useStudentFavouritesListRequest(
    {
      type: "careerzones",
    },
    {
      shouldFetch: !!auth.user,
    },
    { withCredentials: true }
  );

  const isFavourite = favouritesData
    ?.map((favourite) => favourite.entityId)
    .includes(careerZone.id);
  const handleFavouriteToggle = async (event) => {
    if (!auth.user) {
      router.push(updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath));
    }
    else {
      await addToFavourites();

      await updateFavourites();
    }
  };

  return (
    <>
      <div
        className={cx(
          classes.marginAuto,
          classes.bg_colored,
          classes.marginBelow
        )}
      >
        <Card
          className={cx(overviewClasses.jobCard, classes.cardArea, "jobcard")}
        >
          <div className={cx(classes.container)}>
            <h1 className={overviewClasses.generalTitle}>
              {careerZone.name}

              <div className={cx(classes.floatRight, classes.favouriteButton)}>
                {!auth.user || auth.user?.role === ROLE_SCHOOL_USER_ID ? (
                  <>
                    <span onClick={handleFavouriteToggle}>
                      {isFavourite ? (
                        <>
                          <FavoriteIcon
                            height="16px"
                            className={cx(classes.icons, classes.jobIcons)}
                          />
                        </>
                      ) : (
                        <>
                          <FavoriteBorderIcon
                            height="16px"
                            className={cx(classes.icons, classes.jobIcons)}
                          />
                        </>
                      )}
                    </span>
                  </>
                ) : null}
              </div>
            </h1>

            <h4 className={overviewClasses.cardSubTitle}>
              {careerZone.overview}
            </h4>
          </div>
        </Card>
      </div>

      <div className={classes.container}>
        <Grid container justifyContent="space-between" columnSpacing={{ xs: 4, lg: 0 }}>
          <Grid
            item
            className={cx(classes.floatLeft, classes.mainContent)}
            xs={12}
            sm={12}
            md={9}
            lg={8}
          >
            {careerZone?.details?.length > 0 &&
              careerZone.details.filter(detail => !!detail.content).map((detail, i) => (
                <Fragment key={i}>
                  <h2 className={classes.cardTitleSmaller}>{detail.title}</h2>
                  <SanitizeHTML
                    html={detail.content}
                    className="user-content"
                  />
                </Fragment>
              ))}
          </Grid>

          <Grid item xs={12} sm={12} md={3} lg={3}>
            {careerZone && (
              <JobsSidebar
                headingText="Related Jobs"
                careerZones={[careerZone.id]}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
}
